import React from 'react';
import { Navigation } from '../components/Navigation';
import { Artists } from '../components/Artists';
import { Footer } from '../components/Footer';

export const ArtistsPage = () => {
  return (
    <div className="page-transition">
      <Navigation />
      <Artists />
      <Footer />
    </div>
  );
};
